import { normalizeBogglePlaygroundSettings } from '~/boggle/lib/playground'
import { RACE_CORE_PRESET } from '../race/preset'

export const PLAYTEST_CORE_PRESET = normalizeBogglePlaygroundSettings({
  ...RACE_CORE_PRESET,
  intervalTimeSeconds: 20,
  meter: {
    ...RACE_CORE_PRESET.meter,
    capacity: 20,
  },
})
